<template>
    <div id="content" class="full no-padding">
        <div class="bloc">
            <div class="col-lg-2 text-right" style="float: right;">
                <b-form-select v-model="selected" :options="options" @change="resetDates()"></b-form-select>
            </div>
            <div class="col-lg-12" style="float: left;">
                <h4>Carte: </h4>
                <div class="map_fiche" id="map" style="height:580px;">
                    <l-map :zoom="zoom" :center="center" ref="myMap" @ready="doSomethingOnReady()">
                        <l-tile-layer :url="'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'" :attribution="'OpenStreetMap contributors'"/>
                        <l-marker v-for="marker in markers" v-if="isBetweenDates(marker)" :key="marker.id + '_' + marker.marker" :lat-lng="getLatLng(marker.lat, marker.lon)" :icon="getIcon(marker)">
                            <l-popup>
                                <b>{{marker.prenom}} {{marker.nom}}</b> <br>
                                {{marker.adresse_marqueur}} <br>
                                <b>Début:</b> {{marker.date_deb}} <b>Fin:</b> {{marker.date_fin}}
                            </l-popup>
                        </l-marker>
                    </l-map>
                </div>
            </div>
            <div class="col-lg-12" style="float: left;">
                <div class="ecran bloc col-lg-12">
                    <h5>Dates</h5>
                    <div class="content-bloc">
                        <b-row>
                            <b-col style="float: left;" cols="12" lg="3"><b>Date de début: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="3">
                                <b-form-datepicker hide-header :start-weekday="1" v-model="date_deb" placeholder="Date de début" today-button today-button-variant="primary" label-help="" label-today-button="Aujourd'hui"></b-form-datepicker>
                            </b-col>

                            <b-col style="float: left;" cols="12" lg="3"><b>Date de fin (incluse): </b></b-col>
                            <b-col style="float: left;" cols="12" lg="3">
                                <b-form-datepicker hide-header :start-weekday="1" v-model="date_fin" placeholder="Date de fin" today-button today-button-variant="primary" label-help="" label-today-button="Aujourd'hui"></b-form-datepicker>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vuex from "vuex";
import router from "../router/index.js";
import Vue from "vue";
import {LMap, LMarker, LPopup, LTileLayer} from "vue2-leaflet";
import L from "leaflet";

export default {
    name: "Visio",
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup
    },
    data() {
        return {
            selected: 1,
            options: [
                { value: 1, text: 'Aujourd\'hui' },
                { value: 2, text: 'il y a 15 jours' },
                { value: 3, text: 'il y a 1 mois' },
                { value: 4, text: 'il y a 6 mois' },
                { value: 5, text: 'il y a 1 an'}
            ],
            date_deb: new Date(),
            date_fin: new Date(),
            zoom: 15,
            center: L.latLng(window.coords[0], window.coords[1]),
            address: null,
            markers: this.demandes
        }
    },
    async mounted() {
        await this.getDemandes({dossier: '64483'});
        this.markers = this.demandes;
    },
    computed: {
        ...Vuex.mapGetters('Demande', ['demandes']),
    },
    methods: {
        ...Vuex.mapActions('Demande', ['getDemandes']),
        doSomethingOnReady() {
            this.map = this.$refs.myMap.mapObject;
        },
        getLatLng(lat, lng) {
            return L.latLng(lat, lng);
        },
        getIcon(marker) {
            return L.icon({
                iconUrl: require('../assets/marker_' + marker.marker + '-0.png'),
                iconSize: [40, 45],
                iconAnchor: [20, 45]
            })
        },
        getDateDeb() {
            this.date_deb = new Date();
            switch (this.selected) {
                case 1:
                    break;
                case 2:
                    this.date_deb = new Date(Date.now() - 24 * 15 * 3600 * 1000);
                    break;
                case 3:
                    this.date_deb.setMonth(this.date_deb.getMonth() - 1);
                    break;
                case 4:
                    this.date_deb.setMonth(this.date_deb.getMonth() - 6);
                    break;
                case 5:
                    this.date_deb.setFullYear(this.date_deb.getFullYear() - 1);
                    break;
            }

            return this.date_deb;
        },
        getDateFin() {
            this.date_fin = new Date();
            return this.date_fin;
        },
        resetDates() {
            this.getDateDeb();
            this.getDateFin();
        },
        isBetweenDates(marker) {
            let date_deb = new Date(marker.date_deb.split('/')[2]+'-'+marker.date_deb.split('/')[1]+'-'+marker.date_deb.split('/')[0]),
                date_fin = new Date(marker.date_fin.split('/')[2]+'-'+marker.date_fin.split('/')[1]+'-'+marker.date_fin.split('/')[0]);

            let dd= this.date_deb,
                df = this.date_fin;

            if(typeof this.date_deb != 'object')
                dd = new Date(dd);

            if(typeof this.date_fin != 'object')
                df = new Date(df);

            return (dd <= date_deb && df >= date_fin) ||
             (dd >= date_deb && df <= date_fin);
        }
    }
}

</script>